import React, { useState } from "react";
import "./Common_History_Expert.css";
import Common_Rate_Btn from "../common-rate-btn/Common_Rate_Btn";
import History_Expert_Rate_Btn_Modal from "../../header/history/history-expert/history-expert-rate-btn-modal/History_Expert_Rate_Btn_Modal";

const Common_History_Expert = ({ data }) => {
    const [showRateModal, setShowRateModal] = useState(false);
    
        if (!data) return null;
    
        const handleOpenModal = () => setShowRateModal(true);
        const handleCloseModal = () => setShowRateModal(false);

    return (
        <div className="history-expert-card">
            <div className="history-expert-header-bar">
                Details ID: {data.detailsId || "#ORD00000"}
            </div>

            <div className="history-expert-content">
                <div className="history-expert-thumb">
                    <img 
                        src={data.image} 
                        alt={data.name} 
                        className="expert-img" 
                    />
                </div>               
                <div className="history-expert-body">
                    <div className="history-info-row">
                        <span className="info-label">Name:</span>
                        <span className="info-value">{data.name}</span>
                    </div>
                    <div className="history-info-row">
                        <span className="info-label">Field:</span>
                        <span className="info-value">{data.field}</span>
                    </div>
                    <div className="history-info-row">
                        <span className="info-label">Experience:</span>
                        <span className="info-value">{data.experience}</span>
                    </div>
                    <div className="history-info-row">
                        <span className="info-label">Age:</span>
                        <span className="info-value">{data.age}</span>
                    </div>
               
                </div>
            </div>
             
                 <Common_Rate_Btn onBtnClick={handleOpenModal} />
            <History_Expert_Rate_Btn_Modal
                show={showRateModal}
                handleClose={handleCloseModal}
                expertName={data.vendor}
            />
        </div>
           
    );
};


export default Common_History_Expert;